import { render, staticRenderFns } from "./NovidadesView.vue?vue&type=template&id=24def2c6&scoped=true"
import script from "./NovidadesView.vue?vue&type=script&lang=js"
export * from "./NovidadesView.vue?vue&type=script&lang=js"
import style0 from "./NovidadesView.vue?vue&type=style&index=0&id=24def2c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24def2c6",
  null
  
)

export default component.exports